export default "__VITE_ASSET__DeSqZQag__"